import { api } from "@api/api";
import {
  PartnerHistoryEntry,
  PartnerMonthly,
  PartnerReferral,
  PartnerSummary,
} from "@modules/partners/types";

function unwrapList<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[];
  return ((data as { results?: T[] })?.results ?? []) as T[];
}

export async function getPartnerReferralsService(
  id: number | string
): Promise<PartnerReferral[]> {
  const { data } = await api.get(`/v1/partner_admin/${id}/referrals/`);
  return unwrapList<PartnerReferral>(data);
}

export async function getPartnerDetailSummaryService(
  id: number | string
): Promise<PartnerSummary> {
  const { data } = await api.get<PartnerSummary>(`/v1/partner_admin/${id}/summary/`);
  return data;
}

export async function getPartnerMonthlyService(
  id: number | string
): Promise<PartnerMonthly[]> {
  const { data } = await api.get(`/v1/partner_admin/${id}/monthly/`);
  return unwrapList<PartnerMonthly>(data);
}

export async function getPartnerHistoryService(
  id: number | string
): Promise<PartnerHistoryEntry[]> {
  const { data } = await api.get(`/v1/partner_admin/${id}/history/`);
  return unwrapList<PartnerHistoryEntry>(data);
}
